<p class="recording-navigation-blocked-dialog__message">
  You can't leave this page while you are recording. Go back and stop the recording before leaving.
</p>
<footer class="recording-navigation-blocked-dialog__actions">
  <button
    tuiButton
    appearance="primary"
    size="m"
    type="button"
    (click)="dismiss()">
    OK
  </button>
</footer>
